import React, { Fragment, useState } from 'react';
import { Modal } from 'reactstrap';
import PropTypes from 'prop-types';
import ReviewCarousel from '../../Review/components/ReviewCarousel';
import LiveItem from './LiveItem';
import DownloadSingleItemPopup from '../../../shared/components/DownloadPopup/DownloadSingleItemPopup';
import SocialSharePopup from '../../../shared/components/SocialSharePopup/SocialSharePopup';

const LiveGallery = ({
  type,
  items,
}) => {
  const [currentImage, setCurrentImage] = useState(0);
  const [currentDownloadItem, setCurrentDownloadItem] = useState(null);
  const [currentShareItem, setCurrentShareItem] = useState(null);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);
  const [downloadPopupOpened, setDownloadPopupOpened] = useState(false);
  const [socialSharePopupOpened, setSocialSharePopupOpened] = useState(false);

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const onPlayItem = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const openDownloadPopup = (item) => {
    setCurrentDownloadItem(item);
    setDownloadPopupOpened(true);
  };

  const closeDownloadPopup = () => {
    setDownloadPopupOpened(false);
  };

  const openSocialSharePopup = (item) => {
    setCurrentShareItem(item);
    setSocialSharePopupOpened(true);
  };

  const closeSocialSharePopup = () => {
    setSocialSharePopupOpened(false);
  };

  if (items.length > 0) {
    return (
      <Fragment>
        <div className="review-gallery-type"><span>{type}</span></div>
        <div className="review-items">
          {items.map((item, index) => (
            <LiveItem
              item={item}
              type={type}
              onPlay={() => onPlayItem(index)}
              onDownload={() => openDownloadPopup(item)}
              onSocialShare={() => openSocialSharePopup(item)}
            />
          ))}
        </div>
        <Modal
          isOpen={viewerIsOpen}
          centered
          className="modal-full-screen"
        >
          <ReviewCarousel items={items} selectedItem={currentImage} onClose={closeLightbox} />
        </Modal>
        <Modal
          isOpen={downloadPopupOpened}
          centered
          className="modal-full-screen"
        >
          <DownloadSingleItemPopup item={currentDownloadItem} onClose={closeDownloadPopup} />
        </Modal>

        <Modal
          isOpen={socialSharePopupOpened}
          centered
          className="modal-full-screen"
        >
          <SocialSharePopup onClose={closeSocialSharePopup} />
        </Modal>
      </Fragment>
    );
  }

  return null;
};

LiveGallery.propTypes = {
  type: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    src: PropTypes.string,
    thumb: PropTypes.string,
    type: PropTypes.string,
    category: PropTypes.string,
    resolutions: PropTypes.arrayOf(PropTypes.shape({
      type: PropTypes.string,
      src: PropTypes.string,
    })),
  })).isRequired,
};

export default LiveGallery;
